import { useState, useMemo } from "react";
import { aranceles } from "../data/aranceles";

function formatPrecio(n) {
  return "$" + n.toLocaleString("es-CL");
}

export default function Aranceles() {
  const [search, setSearch] = useState("");
  const [expandedCats, setExpandedCats] = useState(() =>
    Object.fromEntries(aranceles.map((c) => [c.categoria, true]))
  );

  const filtered = useMemo(() => {
    const q = search.toLowerCase().trim();
    if (!q) return aranceles;
    return aranceles
      .map((cat) => ({
        ...cat,
        items: cat.items.filter((item) =>
          item.nombre.toLowerCase().includes(q)
        ),
      }))
      .filter((cat) => cat.items.length > 0);
  }, [search]);

  const toggleCat = (cat) =>
    setExpandedCats((prev) => ({ ...prev, [cat]: !prev[cat] }));

  return (
    <section className="px-6 md:px-8 py-8 max-w-5xl mx-auto">
      <div className="section-tag">Aranceles y Protocolos</div>
      <h2 className="section-title">Aranceles de Referencia</h2>

      {/* Search */}
      <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl px-4 py-2.5 mb-5 shadow-sm">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" className="text-gray-400 flex-shrink-0">
          <circle cx="6.5" cy="6.5" r="5" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M10.5 10.5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar procedimiento…"
          className="flex-1 text-sm text-gray-700 placeholder-gray-400 outline-none bg-transparent"
        />
        {search && (
          <button
            onClick={() => setSearch("")}
            className="text-gray-400 hover:text-gray-600 text-xs"
          >
            ✕
          </button>
        )}
      </div>

      {filtered.length === 0 && (
        <div className="text-center py-12 text-gray-400 text-sm">
          No se encontraron procedimientos para "{search}"
        </div>
      )}

      <div className="flex flex-col gap-3">
        {filtered.map((cat) => (
          <div key={cat.categoria} className="card overflow-hidden">
            {/* Category header */}
            <button
              onClick={() => toggleCat(cat.categoria)}
              className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-200 hover:bg-gray-100 transition-colors"
            >
              <span className="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                {cat.categoria}
              </span>
              <div className="flex items-center gap-3">
                <span className="text-[10px] text-gray-400">
                  {cat.items.length} procedimiento{cat.items.length !== 1 ? "s" : ""}
                </span>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  className={`text-gray-400 transition-transform ${
                    expandedCats[cat.categoria] ? "rotate-180" : ""
                  }`}
                >
                  <path
                    d="M3 5l4 4 4-4"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </button>

            {/* Items */}
            {expandedCats[cat.categoria] && (
              <div>
                {cat.items.map((item, i) => (
                  <div
                    key={i}
                    className={`flex items-center justify-between px-4 py-2.5 ${
                      i < cat.items.length - 1 ? "border-b border-gray-100" : ""
                    } hover:bg-gray-50/50 transition-colors`}
                  >
                    <span className="text-sm text-gray-700">{item.nombre}</span>
                    <span className="text-sm font-semibold text-navy-600 bg-gray-100 px-3 py-1 rounded-md tabular-nums ml-4 flex-shrink-0">
                      {formatPrecio(item.precio)}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <p className="text-xs text-gray-400 mt-5 text-center">
        Los valores corresponden al arancel de referencia del convenio. El reembolso es del 85% del valor aprobado.
      </p>
    </section>
  );
}
